import { useState } from 'react'
import PublicLabVerification from '../components/PublicLabVerification'
import LabResultVerification from '../components/LabResultVerification'
import { useAuth } from '../contexts/AuthContext'

export default function LabVerificationPage() {
  const { user } = useAuth()
  const [activeView, setActiveView] = useState<'public' | 'admin'>('public')

  const isStaffOrAdmin = user && (user.role === 'admin' || user.role === 'moderator')

  return (
    <div className="lab-verification-page">
      {isStaffOrAdmin && (
        <div className="admin-controls">
          <div className="view-toggle">
            <button 
              className={`toggle-btn ${activeView === 'public' ? 'active' : ''}`}
              onClick={() => setActiveView('public')}
            >
              🔍 Public Verification
            </button>
            <button 
              className={`toggle-btn ${activeView === 'admin' ? 'active' : ''}`}
              onClick={() => setActiveView('admin')}
            >
              ⚙️ Admin Panel
            </button>
          </div>
        </div>
      )}

      {activeView === 'public' ? (
        <PublicLabVerification />
      ) : (
        <LabResultVerification />
      )}

      <style>{`
        .lab-verification-page {
          min-height: 100vh;
          background: #f5f7fa;
        }

        .admin-controls {
          background: #2d3748;
          padding: 20px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          margin-bottom: 0;
        }

        .view-toggle {
          display: flex;
          justify-content: center;
          gap: 10px;
          max-width: 400px;
          margin: 0 auto;
        }

        .toggle-btn {
          flex: 1;
          padding: 12px 20px;
          border: 2px solid #2c5530;
          background: #2d3748;
          color: #2c5530;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .toggle-btn:hover {
          background: #f8fdf8;
        }

        .toggle-btn.active {
          background: #2c5530;
          color: white;
        }

        @media (max-width: 768px) {
          .view-toggle {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  )
}